export const SALARY_UPDATE = 'SALARY_UPDATE';
